import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification } from 'components/ds';
import PageContainer from '../../../components/PageContainer/PageContainer';
import { pageConfigs } from '../../../configs/pageConfigs';
import { useOtp } from '../../../hooks/useOtp';
import { useSearchUser } from '../../../hooks/useSearchUser';
import {
  TwoFactorValidationCodeComponent
} from '../../../components/TwoFactorValidationCodeComponent/TwoFactorValidationCodeComponent';
import { FactorValidationWrapper } from '../ForgotPasswordOtpRequest/ForgotPasswordOtpRequest.styles';
import { OtpChannelEnum } from '../../../constantes/OtpChannelEnum';
import { useOtpContext } from '../../../context/OtpContextProvider';
import { getChannelValue } from '../../../utils/getChannelValue';

export const ValidateOtpResetPassword: React.FC = () => {
  const [code, setCode] = useState('');
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  
  const navigate = useNavigate();
  const {userData} = useSearchUser();
  const {validateOtpOnForgotPassword, loading, sendOtpRequest, otpId} = useOtp();
  const {selectedChannel, currentFlow} = useOtpContext();
  
  const handleValidateOtpCode = async () => {
    try {
      
      if (!otpId || !userData?.participantId) {
        notification.error({
          message: 'Erro',
          description: 'OTP ID não encontrado. Por favor, solicite um novo código.'
        });
        
        return;
      }
      
      const isValid = await validateOtpOnForgotPassword({
        otpId,
        code,
        participantId: localStorage.getItem('@pwa-participantId') || ''
      });
      
      if (isValid) {
        // Pequeno delay antes de navegar
        await new Promise(resolve => setTimeout(resolve, 500));
        navigate(pageConfigs.validateOtpResetPassword.navigateTo());
      }
    } catch (error: any) {
      console.error('Erro no handleValidateOtpCode:', error);
    }
  };
  
  const handleResend = async () => {
    if (!userData?.participantId || !currentFlow) {
      notification.error({
        message: 'Erro',
        description: 'Dados do usuário não encontrados. Por favor, faça login novamente.'
      });
      
      return;
    }
    
    try {
      const request = {
        participantId: userData.participantId,
        flow: currentFlow,
        channel: selectedChannel
      };
      
      await sendOtpRequest(request);
      setIsResendDisabled(true);
    } catch (error) {
      console.error('Erro ao reenviar código:', error);
      notification.error({
        message: 'Erro ao reenviar código',
        description: 'Não foi possível reenviar o código. Por favor, tente novamente.'
      });
    }
  };
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, 6);
    setCode(value);
  };
  
  const channelValue = getChannelValue(selectedChannel, userData);
  
  // Debug logs para identificar problemas com channelValue
  console.log('ValidateOtpResetPassword - Debug:', {
    selectedChannel,
    userData: userData ? {
      emailObfuscated: userData.emailObfuscated,
      phoneObfuscated: userData.phoneObfuscated,
      participantId: userData.participantId
    } : null,
    channelValue
  });
  
  const codeLength = 6;
  
  return (
    <PageContainer
      title={pageConfigs.validateOtpResetPassword.title}
      navigateBack={pageConfigs.validateOtpResetPassword.navigateBack()}
      buttonText={pageConfigs.validateOtpResetPassword.buttonLabel}
      thereIsButton
      loading={loading}
      onClick={handleValidateOtpCode}
      disabled={loading || (code.length !== codeLength)}
    >
      <FactorValidationWrapper>
        <TwoFactorValidationCodeComponent
          code={code}
          isResendDisabled={isResendDisabled}
          channelValue={channelValue}
          onCodeChange={handleInputChange}
          onSubmit={handleValidateOtpCode}
          onResend={handleResend}
          setIsResendDisabled={setIsResendDisabled}
        />
      </FactorValidationWrapper>
    </PageContainer>
  );
};
